import { render, staticRenderFns } from "./Ending.vue?vue&type=template&id=499b92ee&scoped=true&"
import script from "./Ending.vue?vue&type=script&lang=js&"
export * from "./Ending.vue?vue&type=script&lang=js&"
import style0 from "./Ending.vue?vue&type=style&index=0&id=499b92ee&lang=less&scoped=true&"
import style1 from "./Ending.vue?vue&type=style&index=1&id=499b92ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b92ee",
  null
  
)

export default component.exports